import { UtmSource } from '../../../../../../services/exports/Constants';
import { CustomUtmSource } from '../../../../../../views/marketing/tracking-links';

export default {
  title: 'Tracking Links',
  utm_sources: {
    [UtmSource.GoogleBusinessProfile]: 'Google business',
    [UtmSource.SocialMedia]: 'Social media',
  },
  form: {
    utm_source: {
      label: 'Source',
      placeholder: 'Select source',
      options: {
        [UtmSource.GoogleBusinessProfile]: 'Google business',
        [UtmSource.SocialMedia]: 'Other social media',
        [CustomUtmSource.Other]: 'Other',
      },
    },
    utm_source_details: {
      label: 'Custom source',
      placeholder: 'Enter source',
    },
    target_product: {
      label: 'Target',
      placeholder: 'Select target',
    },
    target_url: {
      label: 'Target URL',
      placeholder: 'https://google.com',
    },
    utm_medium: {
      label: 'Medium',
      placeholder: 'Enter medium',
    },
    utm_campaign: {
      label: 'Campaign',
      placeholder: 'Enter campaign',
    },
  },
  fields: {
    utm_source: 'Source',
    target_product: 'Target',
    type: 'Type',
    utm_medium: 'Medium',
    utm_campaign: 'Campaign',
    utm_referrer_id: 'Referrer ID',
  },
  buttons: {
    create_auto_links: 'Create automatic links',
    create_link: 'Create link',
    create: 'Create',
    update: 'Update',
    copy_link: 'Copy link',
    download_qr_code: 'Download QR code',
    edit: 'Edit',
  },
  modals: {
    auto_links_creation: {
      title: 'Are you sure?',
      description:
        'Make sure you have finished store configuration (online shop subdomain / storefront domain), changing those after links creation will not be automatically affecting the existing links!',
    },
  },
  toasts: {
    failed_to_load_data: 'Failed to load data',
    failed_to_save_changes: 'Failed to save changes',
    changes_got_saved: 'Changes got saved',
    link_got_copied: 'Link got copied!',
    failed_to_download_qr_code: 'Failed to download qr code',
  },
};
